<div class="w-full flex flex-col flex-1 min-h-0">
<div class="flex flex-col flex-1 min-h-0 overflow-hidden">

  <!-- Primera carga: tabla Skeleton -->
  @if (loading() && !initialLoadDone()) {
    <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
      <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p-skeleton width="8rem" height="1.5rem" class="mb-2" />
            <p-skeleton width="14rem" height="0.875rem" />
          </div>
        </div>
      </div>
      <div class="flex-1 min-h-0 overflow-auto">
        <table class="w-full border-collapse">
          <thead class="bg-slate-50 border-b border-slate-200">
            <tr>
              <th>Factura</th>
              <th>Cliente</th>
              <th>Venta</th>
              <th>Estatus CFDI</th>
              <th>Estado</th>
              <th>Fecha de emisión</th>
              <th>Subtotal</th>
              <th>Impuestos</th>
              <th>Total</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-slate-100">
            @for (row of skeletonRows; track row) {
              <tr>
                <td class="px-2 py-2"><div class="flex items-center gap-2"><p-skeleton shape="circle" size="2.5rem" /><p-skeleton width="7rem" height="0.875rem" /></div></td>
                <td class="px-2 py-2"><p-skeleton width="10rem" height="0.875rem" class="mb-1" /><p-skeleton width="8rem" height="0.75rem" /></td>
                <td class="px-2 py-2 hidden sm:table-cell"><p-skeleton width="4rem" height="0.875rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="5rem" height="1.25rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="4rem" height="1.25rem" /></td>
                <td class="px-2 py-2"><p-skeleton width="6rem" height="0.875rem" /></td>
                <td class="px-2 py-2 text-right"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2 text-right"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2 text-right"><p-skeleton width="5rem" height="0.875rem" /></td>
                <td class="px-2 py-2 text-right w-[100px]"><p-skeleton width="4rem" height="2rem" /></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="bg-slate-50 px-6 py-4 border-t border-slate-200 flex justify-end shrink-0">
        <p-skeleton width="12rem" height="2rem" />
      </div>
    </div>
  }

  <!-- Error State -->
  @if (error() && !loading()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
      <div class="flex items-center">
        <mat-icon class="text-red-600 mr-2">error</mat-icon>
        <p class="text-red-800">{{ error() }}</p>
      </div>
      <button
        (click)="loadInvoices()"
        class="mt-3 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
        Reintentar
      </button>
    </div>
  }

  @if (initialLoadDone() && !error()) {
    <div class="flex-1 min-h-0 flex flex-col">
      <div class="flex-1 min-h-0 flex flex-col bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-5 border-b border-slate-200 bg-slate-50/50 shrink-0">
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2">
                <span class="flex h-9 w-9 items-center justify-center rounded-lg bg-sky-100 text-sky-600">
                  <i class="pi pi-file"></i>
                </span>
                Facturas
              </h2>
              <p class="text-sm text-slate-500 mt-1">Catálogo de CFDIs generados. Esta sección es de solo lectura.</p>
            </div>
          </div>
        </div>

        <div [formGroup]="filtersForm" class="border-b border-slate-200 bg-slate-50 shrink-0 px-3 py-2">
          <div class="grid grid-cols-2 xl:flex xl:flex-wrap xl:items-end gap-2">
            <div class="min-w-0 xl:w-28">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <input pInputText id="filterInvoicesFolio" formControlName="folio" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.folio.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.folio.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterInvoicesFolio">Folio</label>
              </p-floatlabel>
            </div>
            <div class="min-w-0 xl:w-28">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <input pInputText id="filterInvoicesSerie" formControlName="serie" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.serie.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.serie.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterInvoicesSerie">Serie</label>
              </p-floatlabel>
            </div>
            <div class="min-w-0 col-span-2 sm:col-span-1 xl:w-44">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <input pInputText id="filterInvoicesInvoiceId" formControlName="invoiceId" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.invoiceId.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.invoiceId.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterInvoicesInvoiceId">UUID SAT</label>
              </p-floatlabel>
            </div>
            <div class="min-w-0 col-span-2 sm:col-span-1 xl:flex-1 xl:min-w-40">
              <p-floatlabel class="w-full" variant="on">
                <p-iconfield class="w-full">
                  <p-inputicon class="pi pi-search text-sm" />
                  <input pInputText id="filterInvoicesQ" formControlName="q" class="w-full p-inputtext-sm" autocomplete="off" />
                  @if (filtersForm.controls.q.value) {
                    <p-inputicon class="pi pi-times text-sm cursor-pointer" (click)="filtersForm.controls.q.setValue('', { emitEvent: false }); applyFilters()" />
                  }
                </p-iconfield>
                <label for="filterInvoicesQ">Cliente o RFC</label>
              </p-floatlabel>
            </div>
            <p-floatlabel class="w-full min-w-0 xl:w-40" variant="on">
              <p-select
                formControlName="status"
                inputId="filterInvoicesStatus"
                [options]="statusFilterOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="filterInvoicesStatus">Estatus CFDI</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 xl:w-32" variant="on">
              <p-select
                formControlName="state"
                inputId="filterInvoicesState"
                [options]="stateFilterOptions"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"
                class="w-full" />
              <label for="filterInvoicesState">Estado</label>
            </p-floatlabel>
            <p-floatlabel class="w-full min-w-0 col-span-2 sm:col-span-1 xl:w-64" variant="on">
              <p-datepicker
                inputId="filterInvoicesIssueDate"
                formControlName="issueDateRange"
                selectionMode="range"
                [readonlyInput]="true"
                dateFormat="dd/mm/yy"
                showIcon
                iconDisplay="input"
                [showClear]="true"
                size="small"
                appendTo="body"
                class="w-full" />
              <label for="filterInvoicesIssueDate">Rango F. emisión</label>
            </p-floatlabel>
            @if (hasActiveFilters()) {
              <div class="flex items-end col-span-2 sm:col-span-1">
                <p-button
                  icon="pi pi-times"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  severity="secondary"
                  type="button"
                  (onClick)="clearFilters()"
                  ariaLabel="Limpiar filtros" />
              </div>
            }
          </div>
        </div>

        <div class="flex-1 min-h-0 overflow-hidden">
          <p-menu #rowActionsMenu [model]="rowMenuItems()" [popup]="true" appendTo="body" />
          <p-table
            #dtInvoices
            [value]="invoices()"
            dataKey="id"
            [lazy]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [totalRecords]="totalItems()"
            [first]="currentPage() * pageSize()"
            [rows]="pageSize()"
            [rowsPerPageOptions]="pageSizeOptions"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} facturas"
            [loading]="loading()"
            [paginator]="true"
            (onLazyLoad)="onLazyLoad($event)"
            [tableStyle]="{ width: '100%' }"
            styleClass="invoices-primeng-table p-datatable-striped p-datatable-sm"
            [rowHover]="true"
            paginatorStyleClass="!border-0 !bg-transparent !pt-4 !flex !items-center !justify-between"
          >
            <ng-template pTemplate="paginatorleft">
              <span
                class="inline-flex"
                [pTooltip]="exportButtonTooltip"
                tooltipPosition="top"
                appendTo="body">
                <p-button
                  label="Exportar CSV"
                  icon="pi pi-download"
                  severity="secondary"
                  size="small"
                  [rounded]="true"
                  [loading]="exporting()"
                  [disabled]="!canExportInvoices || exporting() || totalItems() === 0"
                  (onClick)="exportCsv()" />
              </span>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th class="!px-2">Factura</th>
                <th class="!px-2">Cliente</th>
                <th class="!px-2 hidden sm:table-cell !whitespace-nowrap">Venta</th>
                <th class="!px-2 !whitespace-nowrap">Estatus CFDI</th>
                <th class="!px-2 !whitespace-nowrap">Estado</th>
                <th class="!px-2 !whitespace-nowrap !text-center">Fecha de emisión</th>
                <th class="!px-2 !whitespace-nowrap !text-right">Subtotal</th>
                <th class="!px-2 !whitespace-nowrap !text-right">Impuestos</th>
                <th class="!px-2 !whitespace-nowrap !text-right">Total</th>
                <th class="!px-2 !whitespace-nowrap !text-right">Acciones</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-invoice>
              <tr class="cursor-pointer hover:!bg-sky-50/50 transition-colors !border-slate-100" (click)="openInvoiceDetails(invoice)">
                <td class="!px-2 !py-2 !border-slate-100">
                  <div class="flex items-center gap-2">
                    <div class="shrink-0 h-8 w-8 rounded-full flex items-center justify-center bg-sky-100 text-sky-600 [&>i]:text-sm">
                      <i class="pi pi-file"></i>
                    </div>
                    <div class="min-w-0">
                      <div class="text-sm font-medium text-slate-900 truncate">{{ getInvoiceLabel(invoice) }}</div>
                      <div class="text-xs text-slate-500 truncate">{{ invoice.invoiceId || 'CFDI' }}</div>
                    </div>
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 max-w-[12rem]" (click)="$event.stopPropagation()">
                  <div class="min-w-0">
                    @if (invoice.customer?.id) {
                      <button
                        type="button"
                        class="block w-full text-left text-sm font-medium text-slate-900 truncate hover:text-sky-700"
                        (click)="openCustomerDetails(invoice.customer.id, $event)">
                        {{ invoice.customer?.legalName || '-' }}
                      </button>
                      <div class="text-xs text-slate-500 truncate">{{ invoice.customer?.comercialName || '-' }}</div>
                    } @else {
                      <div class="text-sm font-medium text-slate-900 truncate">{{ invoice.customer?.legalName || '-' }}</div>
                      <div class="text-xs text-slate-500 truncate">{{ invoice.customer?.comercialName || '-' }}</div>
                    }
                  </div>
                </td>
                <td class="!px-2 !py-2 !border-slate-100 hidden sm:table-cell text-sm text-slate-700 !whitespace-nowrap">
                  @if (invoice.saleId) {
                    <button
                      type="button"
                      class="text-sky-600 hover:text-sky-800 hover:underline"
                      (click)="openSaleDetails(invoice.saleId, $event)">
                      {{ invoice.saleNumber || ('#' + invoice.saleId) }}
                    </button>
                  } @else {
                    -
                  }
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap">
                  <p-tag
                    class="!text-xs"
                    [value]="getInvoiceStatusLabel(invoice.status)"
                    [severity]="getInvoiceStatusSeverity(invoice.status)" />
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !whitespace-nowrap">
                  <p-tag
                    class="!text-xs"
                    [value]="invoice.state === 'ACTIVE' ? 'Activo' : 'Inactivo'"
                    [severity]="getStateSeverity(invoice.state) ?? undefined" />
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-600 !whitespace-nowrap !text-center">
                  {{ invoice.issueDate ? (invoice.issueDate | date:'dd/MM/yyyy HH:mm') : '-' }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-900 !whitespace-nowrap !text-right">
                  {{ (invoice.subtotal ?? 0) | number:'1.2-2' }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-900 !whitespace-nowrap !text-right">
                  {{ (invoice.tax ?? 0) | number:'1.2-2' }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 text-sm text-slate-900 !whitespace-nowrap !text-right">
                  {{ (invoice.total ?? 0) | number:'1.2-2' }}
                </td>
                <td class="!px-2 !py-2 !border-slate-100 !text-right !whitespace-nowrap" (click)="$event.stopPropagation()" pFrozenColumn>
                  <p-button
                    icon="pi pi-ellipsis-v"
                    rounded
                    [text]="true"
                    severity="secondary"
                    styleClass="hover:!bg-sky-100"
                    [loading]="cfdiPdfViewerOpening() || downloadPdfLoading() || downloadXmlLoading() || resendCfdiLoading()"
                    [disabled]="cfdiPdfViewerOpening() || downloadPdfLoading() || downloadXmlLoading() || resendCfdiLoading()"
                    (onClick)="openRowMenu($event, invoice)" />
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="10" class="!px-2 !py-12 !text-center !text-slate-500 !border-slate-100">
                  No se encontraron facturas con los filtros aplicados.
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  }

</div>

  <p-drawer
    [visible]="isDetailsOpen()"
    position="right"
    (visibleChange)="onDrawerVisibleChange($event)"
    styleClass="!w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full pr-2 border-b border-slate-200 pb-3 gap-3">
        <div class="min-w-0">
          <h3 class="text-lg font-semibold text-slate-900">Detalle de factura</h3>
          @if (selectedInvoice(); as inv) {
            <p class="text-sm text-slate-500 mt-0.5 truncate">{{ getInvoiceLabel(inv) }}</p>
          }
        </div>
        @if (selectedInvoice(); as inv) {
          <p-button
            label="Ver factura"
            icon="pi pi-eye"
            size="small"
            [rounded]="true"
            [loading]="cfdiPdfViewerOpening()"
            [disabled]="!inv.pdfFileId || inv.id == null || cfdiPdfViewerOpening()"
            (onClick)="openCfdiPdfViewer(inv)"
            pTooltip="Vista previa del PDF del CFDI"
          />
        }
      </div>
    </ng-template>
    @if (detailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando detalle...</p>
      </div>
    } @else if (selectedInvoice(); as inv) {
      <div class="flex flex-col gap-6 py-2 pr-1">
        <div class="flex items-center gap-4 p-4 rounded-xl bg-slate-50 border border-slate-200">
          <div class="shrink-0 h-14 w-14 rounded-full flex items-center justify-center bg-sky-100 text-sky-600 [&>i]:text-2xl">
            <i class="pi pi-file"></i>
          </div>
          <div class="min-w-0 flex-1">
            <p class="text-base font-semibold text-slate-900">{{ getInvoiceLabel(inv) }}</p>
            <p class="text-xs text-slate-500 font-mono mt-1 truncate">{{ inv.invoiceId || 'Sin UUID' }}</p>
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5">
          <div class="py-3 border-b border-slate-100">
            <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1">Serie</p>
            <p class="text-sm text-slate-700">{{ inv.serie || '-' }}</p>
          </div>
          <div class="py-3 border-b border-slate-100">
            <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1">Folio</p>
            <p class="text-sm text-slate-700">{{ inv.folio || '-' }}</p>
          </div>
          <div class="py-3 border-b border-slate-100">
            <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1">Fecha de emisión</p>
            <p class="text-sm text-slate-700">{{ inv.issueDate ? (inv.issueDate | date:'dd/MM/yyyy HH:mm') : '-' }}</p>
          </div>
          <div class="py-3 border-b border-slate-100">
            <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1">Estatus CFDI</p>
            <p-tag
              class="!text-xs"
              [value]="getInvoiceStatusLabel(inv.status)"
              [severity]="getInvoiceStatusSeverity(inv.status)" />
          </div>
          <div class="py-3 border-b border-slate-100">
            <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1">Estado</p>
            <p-tag
              class="!text-xs"
              [value]="inv.state === 'ACTIVE' ? 'Activo' : 'Inactivo'"
              [severity]="getStateSeverity(inv.state) ?? undefined" />
          </div>
          <div class="py-3 border-b border-slate-100">
            <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1">Proveedor</p>
            <p class="text-sm text-slate-700">{{ inv.providerId || '-' }}</p>
          </div>
          <div class="py-3 border-b border-slate-100 sm:col-span-2">
            <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1">UUID SAT</p>
            <p class="text-sm text-slate-700 font-mono break-all">{{ inv.invoiceId || '-' }}</p>
          </div>
        </div>

        @if (inv.customer || inv.saleId) {
          <div class="p-4 rounded-xl bg-slate-50 border border-slate-200">
            <p class="flex items-center gap-2 text-xs font-semibold text-slate-600 uppercase tracking-wide mb-3">
              <span class="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-100 text-emerald-600">
                <i class="pi pi-user"></i>
              </span>
              Cliente / Venta
            </p>
            <div class="space-y-1.5">
              <div>
                <p class="text-xs font-medium text-slate-500">Cliente</p>
                @if (inv.customer?.id) {
                  <button
                    type="button"
                    class="text-sm font-medium text-sky-600 hover:text-sky-800 hover:underline"
                    (click)="openCustomerDetails(inv.customer.id)">
                    {{ inv.customer?.comercialName || inv.customer?.legalName || '-' }}
                  </button>
                } @else {
                  <p class="text-sm font-medium text-slate-900">{{ inv.customer?.comercialName || inv.customer?.legalName || '-' }}</p>
                }
              </div>
              @if (inv.customer?.taxId) {
                <div>
                  <p class="text-xs font-medium text-slate-500">RFC</p>
                  <p class="text-sm text-slate-700 font-mono">{{ inv.customer.taxId }}</p>
                </div>
              }
            </div>
            @if (inv.saleId) {
              <button
                type="button"
                class="inline-flex items-center gap-2 mt-3 text-sm font-medium text-sky-600 hover:text-sky-800"
                (click)="openSaleDetails(inv.saleId)">
                <i class="pi pi-external-link shrink-0"></i>
                <span class="underline underline-offset-2">Ver venta {{ inv.saleNumber || ('#' + inv.saleId) }}</span>
              </button>
            }
          </div>
        }

        <div class="flex flex-wrap gap-3">
          <p-button
            label="Descargar PDF"
            icon="pi pi-file-pdf"
            severity="secondary"
            [loading]="downloadPdfLoading()"
            [disabled]="!inv.pdfFileId || inv.id == null"
            (onClick)="downloadStampPDF(inv)" />
          <p-button
            label="Descargar XML"
            icon="pi pi-file"
            severity="secondary"
            [loading]="downloadXmlLoading()"
            [disabled]="!inv.xmlFileId || inv.id == null"
            (onClick)="downloadStampXML(inv)" />
          <p-button
            label="Reenviar CFDI"
            icon="pi pi-send"
            severity="secondary"
            [loading]="resendCfdiLoading()"
            [disabled]="resendCfdiLoading() || inv.id == null || (!inv.pdfFileId && !inv.xmlFileId)"
            (onClick)="openResendCfdiDialog(inv)"
            appDisableUnless="INVOICE_WRITE" />
        </div>
      </div>
    }
  </p-drawer>

  <p-dialog
    [visible]="resendCfdiDialogVisible()"
    (visibleChange)="!$event ? closeResendCfdiDialog() : resendCfdiDialogVisible.set($event)"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="!resendCfdiLoading()"
    [closable]="!resendCfdiLoading()"
    appendTo="body"
    [style]="{ width: 'min(26rem, calc(100vw - 2rem))' }"
    header="Reenviar CFDI"
  >
    <div class="flex flex-col gap-4 pt-1">
      <p class="text-sm text-slate-600 m-0">
        Indica el correo al que se enviará el PDF y el XML del CFDI.
      </p>
      <p-floatlabel variant="on">
        <input
          pInputText
          id="resend-cfdi-email-invoices"
          class="w-full"
          type="email"
          autocomplete="email"
          [ngModel]="resendCfdiEmail()"
          (ngModelChange)="resendCfdiEmail.set($event)"
          [disabled]="resendCfdiLoading()"
        />
        <label for="resend-cfdi-email-invoices">Correo electrónico</label>
      </p-floatlabel>
    </div>
    <ng-template #footer>
      <div class="flex justify-end gap-2">
        <p-button
          label="Cancelar"
          severity="secondary"
          [text]="true"
          type="button"
          [disabled]="resendCfdiLoading()"
          (onClick)="closeResendCfdiDialog()"
        />
        <p-button
          label="Enviar"
          icon="pi pi-send"
          type="button"
          [loading]="resendCfdiLoading()"
          [disabled]="resendCfdiLoading() || !resendCfdiEmail().trim()"
          (onClick)="submitResendCfdi()"
        />
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog
    [visible]="cfdiPdfViewerVisible()"
    (visibleChange)="onCfdiPdfViewerVisibleChange($event)"
    [modal]="true"
    [draggable]="false"
    [resizable]="true"
    [dismissableMask]="true"
    [closable]="true"
    appendTo="body"
    [style]="{ width: 'min(56rem, calc(100vw - 1.5rem))' }"
    [contentStyle]="{ padding: '0' }"
    styleClass="cfdi-pdf-viewer-dialog"
    header="CFDI — vista PDF"
    [focusOnShow]="true"
  >
    @if (cfdiPdfViewerSafeUrl(); as pdfSrc) {
      <iframe
        [src]="pdfSrc"
        class="block min-h-[72vh] w-full rounded-b-lg border-0 bg-slate-100"
        title="Vista previa del PDF del CFDI"
      ></iframe>
    } @else {
      <div class="flex min-h-[12rem] items-center justify-center text-slate-500">
        <i class="pi pi-spin pi-spinner mr-2"></i>
        <span>Cargando vista previa…</span>
      </div>
    }
  </p-dialog>

  <p-drawer
    [visible]="isSaleDetailsOpen()"
    position="right"
    (visibleChange)="onSaleDrawerVisibleChange($event)"
    styleClass="sale-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-violet-100 text-violet-600 shadow-sm">
            <i class="pi pi-shopping-cart text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalle de venta</h3>
        </div>
        @if (selectedSale() && !saleDetailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editSaleFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (saleDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando detalle...</p>
      </div>
    } @else if (selectedSale()) {
      <app-sale-read
        [sale]="selectedSale()!"
        [charges]="saleCharges()"
        (openCustomer)="openCustomerDetails($event)"
        (openSubscription)="openSubscriptionDetails($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="isCustomerDetailsOpen()"
    position="right"
    (visibleChange)="onCustomerDrawerVisibleChange($event)"
    styleClass="customer-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-sky-100 text-sky-600 shadow-sm">
            <i class="pi pi-user text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalles del cliente</h3>
        </div>
        @if (selectedCustomer() && !customerDetailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editCustomerFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (customerDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-sky-500"></i>
        <p class="text-sm text-slate-600">Cargando cliente...</p>
      </div>
    } @else if (selectedCustomer()) {
      <app-customer-read
        [customer]="selectedCustomer()!"
        (openSale)="openSaleDetailsFromCustomer($event)" />
    }
  </p-drawer>

  <p-drawer
    [visible]="isSubscriptionDetailsOpen()"
    position="right"
    (visibleChange)="onSubscriptionDrawerVisibleChange($event)"
    styleClass="subscription-details-drawer !w-[800px]"
    [blockScroll]="true">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-100 text-teal-600 shadow-sm">
            <i class="pi pi-sync text-base"></i>
          </span>
          <h3 class="text-lg font-semibold text-slate-900">Detalle de suscripción</h3>
        </div>
        @if (selectedSubscription() && !subscriptionDetailsLoading()) {
          <button
            type="button"
            class="inline-flex items-center gap-2 text-sm font-semibold bg-blue-600 text-white px-3 py-2 rounded-lg shadow-sm hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 shrink-0"
            (click)="editSubscriptionFromModal()">
            <i class="pi pi-pencil text-sm"></i>
            Editar
          </button>
        }
      </div>
    </ng-template>
    @if (subscriptionDetailsLoading()) {
      <div class="flex flex-col items-center justify-center py-12 gap-4">
        <i class="pi pi-spin pi-spinner text-4xl text-teal-500"></i>
        <p class="text-sm text-slate-600">Cargando suscripción...</p>
      </div>
    } @else if (selectedSubscription()) {
      <app-subscription-read
        [subscription]="selectedSubscription()!"
        (openSale)="openSaleDetailsFromCustomer($event)" />
    }
  </p-drawer>
</div>
